<template>
  <vjs-modal v-bind="$options.propsData" :icon="variant_icon" :width="width">
    <template slot="body-content">
      <slot v-if="$scopedSlots['default']" />
      <div v-else style="font-weight: bold">
        {{ message }}
      </div>
    </template>
    <template slot="body-controls">
      <b-button variant="ss" @click="() => complete({ confirm: true })">
        {{ confirmText }}
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  name: `alert-modal`,
  components: {
    VjsModal,
  },
  mixins: [VjsModalMixin],
  props: {
    message: {
      type: String,
      required: false,
      default: ``,
    },
    variant: {
      type: String,
      required: false,
      default: `info`,
    },
    width: {
      type: String,
      required: false,
      default: `500`,
    },
    confirmText: {
      type: String,
      required: false,
      default: `Confirm`,
    },
  },
  computed: {
    variant_icon() {
      switch (this.variant) {
        case `error`:
          return `la la-exclamation-triangle`;
        case `success`:
          return `la la-check-circle`;
        case `info`:
        default:
          return `la la-info-circle`;
      }
    },
  },
};
</script>
